import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { TimedPlusStatus } from '../TimedPlusCountdown/types/TimedPlusStatus.enum';
import BiddingCountdown from '../Countdown/BiddingCountdown';
import styled, { css } from 'styled-components';
import TimedPlusTooltip from './TimedPlusTooltip';

export type TimedPlusCountdownProps = {
    // has the item's timed+ status been extended
    isExtended: boolean;
    // the item's current timed+ end time
    saleEndTimestamp: number;
};

const TimedPlusCountdown = ({ isExtended, saleEndTimestamp }: TimedPlusCountdownProps) => {
    const timedPlusStatus: TimedPlusStatus = isExtended ? TimedPlusStatus.Extended : TimedPlusStatus.Started;
    const timedPlusLabel: string = isExtended ? 'countdownDesktop' : 'countdownOnly';

    const labelId = `itemPage.biddingInfo.timedPlus.${timedPlusStatus}.${timedPlusLabel}`;

    return (
        <StyledTimedPlusCountdownLabel>
            <FormattedMessage
                id={labelId}
                values={{
                    countdown: (
                        <BiddingCountdown
                            isLive
                            timestamp={saleEndTimestamp}
                        />
                    ),
                    info: <TimedPlusTooltip />,
                }}
            />
        </StyledTimedPlusCountdownLabel>
    );
};

export default TimedPlusCountdown;

const StyledTimedPlusCountdownLabel = styled(BodySecondary)`
    display: flex;
    ${({ theme }) => css`
        color: ${theme.colors.red100};

        // 5px margins to overwrite the countdown's 6px margins
        & > [data-testid='countdown'] {
            margin-left: 5px;

            & > div {
                margin-left: 0 !important;
                margin-right: 5px !important;
            }
        }
    `}
`;
